module.exports.STAR_UUID = '00000000-0000-0000-0000-000000000000';
module.exports.UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;